export default __webpack_public_path__ + "static/media/Westermarck Short Bow.b4683229.jpg";